import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";

import InputMask from "react-input-mask";

import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles(theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const MobileData = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  basic_data,
  user,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "basic_data");
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Usar este subcontacto para APP?
        </Typography>
        <Select
          native
          name="user_id"
          inputProps={{
            name: "user_id",
            className: "user_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          value={basic_data.user_id}
          input={<Input id="grouped-native-select" name="user_id" />}
        >
          <option value={user.id}>Si</option>
          <option value="">No</option>
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

export default MobileData;
